'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navLinks = [
  { href: '/products', label: 'Products' },
  { href: '/social-selling', label: 'Social Selling' },
  { href: '/book-demo', label: 'Book a Demo' },
  { href: '/store', label: 'Store' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header className="sticky top-0 z-50 border-b border-[#1E3352] bg-[#0F1B2D]/95 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#00C9A7] flex items-center justify-center">
              <span className="text-[#0F1B2D] font-black text-sm">M</span>
            </div>
            <span className="font-extrabold text-lg text-white tracking-tight">MANGQASHA IT SOLUTIONS</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  pathname === link?.href
                    ? 'text-[#00C9A7] bg-[#00C9A7]/10'
                    : 'text-[#94A3B8] hover:text-white hover:bg-[#1A2D45]'
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Link href="/dashboard" className="text-sm text-[#94A3B8] hover:text-white transition-colors font-medium">
              Login
            </Link>
            <Link
              href="/book-demo"
              className="btn-primary px-4 py-2 text-sm"
            >
              Book Demo
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            className="md:hidden p-2 text-[#94A3B8] hover:text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <XMarkIcon className="w-5 h-5" /> : <Bars3Icon className="w-5 h-5" />}
          </button>
        </div>
      </div>
      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-[#1E3352] bg-[#0F1B2D] px-4 py-4 space-y-1">
          {navLinks?.map((link) => (
            <Link
              key={link?.href}
              href={link?.href}
              className="block px-4 py-2.5 rounded-lg text-sm font-medium text-[#94A3B8] hover:text-white hover:bg-[#1A2D45]"
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </Link>
          ))}
          <div className="pt-3 flex flex-col gap-2">
            <Link href="/dashboard" className="block px-4 py-2.5 text-sm text-[#94A3B8] hover:text-white">Login</Link>
            <Link href="/book-demo" className="btn-primary px-4 py-2.5 text-sm text-center">Book Demo</Link>
          </div>
        </div>
      )}
    </header>
  );
}
